import React from 'react';
import PropTypes from 'prop-types';
import { Card, Skeleton } from 'antd';
import Router from '../../routes';
import styles from './styles.less';

const CardJob = ({ data }) => {
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    if (Object.keys(data).length) {
      setLoading(false);
    }
  }, [Object.keys(data)]);

  const handleClick = () => {
    Router.pushRoute('jobs', {
      queryParams: { jobLink: data.url },
    });
  };

  return (
    <div onClick={handleClick} className={styles.cardContainer}>
      <Card
        className={styles.card}
        cover={
          <div className={styles.imageContainer}>
            <img
              className={styles.image}
              src={
                data.company_logo ||
                'https://image.freepik.com/free-vector/company-logo-with-avatar-design_1465-2.jpg'
              }
              alt={data.jobTitle}
            />
          </div>
        }
      >
        <Skeleton loading={loading} active paragraph={{ rows: 1 }} style={{ width: '80%' }}>
          <div style={{ overflow: 'hidden', maxWidth: '233px', width: 'fit-content' }}>
            <p className={styles.jobCompanyTitle}>{data.company}</p>
            {data.jobTitle && (
              <p className={styles.jobCompanyTitle} name="wizard_course_title">
                {data.jobTitle}
              </p>
            )}
            <div className={styles.footer}>
              <p className={styles.salary}>
                {typeof data.salary === 'number' ? data.salary : ''}
              </p>
            </div>
          </div>
        </Skeleton>
      </Card>
    </div>
  );
};

CardJob.propTypes = {
  data: PropTypes.object.isRequired,
};

CardJob.defaultProps = {};

export default CardJob;
